<div class="products-container">
  <!-- Compact header with title, toolbar and tabs combined -->
  <div class="header-container">
    <div>
      <!-- Removed the heat map from here -->
    </div>
    <p-toolbar styleClass="compact-toolbar p-0 surface-0">
      <div class="p-toolbar-group-start flex flex-row align-items-center">
        <div class="inline-tabs">
          <p-tabs [(value)]="activeTab" styleClass="society-tabs">
            <p-tablist>
              @for (tab of mlSocieties; track tab.id) {
                <p-tab [value]="tab.id">
                  <div class="tab-header">
                    <i class="{{ tab.icon }} mr-2"></i>
                    <p-badge
                      [value]="societyCounts[tab.id] || 0"
                      severity="info"
                      styleClass="ml-2"
                    >
                    </p-badge>
                  </div>
                </p-tab>
              }
            </p-tablist>
          </p-tabs>
        </div>
      </div>
      <div
        *ngIf="filtersOpened"
        style="display: flex; gap: 20px; align-items: center"
      >
        <p-iconfield iconPosition="left">
          <p-inputicon styleClass="pi pi-search" />
          <p-select
            [options]="marketTypes"
            [filter]="true"
            placeholder="Type marché"
            [(ngModel)]="selectedMarketType"
            class="w-full md:w-56"
            (onChange)="applyFilters()"
          />
        </p-iconfield>
        <p-iconfield iconPosition="left">
          <p-inputicon styleClass="pi pi-search" />
          <p-select
            [options]="allDepartements"
            [filter]="true"
            placeholder="Recherche par dpt."
            class="w-full md:w-56"
            [(ngModel)]="selectedDepartment"
            (onChange)="applyFilters()"
          />
        </p-iconfield>
        <p-button
          icon="pi pi-times"
          styleClass="p-button-outlined p-button-rounded mr-2"
          (click)="resetFilters()"
          pTooltip="Effacer"
        ></p-button>
      </div>
      <ng-template #end>
        <p-button
          icon="pi pi-map-marker"
          styleClass="p-button-outlined p-button-rounded mr-2"
          (click)="isMapOpened = !isMapOpened"
          pTooltip="{{ isMapOpened ? 'Fermer' : 'Ouvrir' }} la carte"
        ></p-button>
        <p-button
          icon="pi pi-sync"
          styleClass="p-button-outlined p-button-rounded mr-2"
          (click)="refreshData()"
          [loading]="(loading$ | async) || false"
          pTooltip="Rafraîchir"
        ></p-button>
        <p-button
          icon="pi pi-filter"
          styleClass="p-button-outlined p-button-rounded"
          pTooltip="Filtres avancés"
          [ngStyle]="{
            'background-color': filtersOpened
              ? 'hsl(158.32deg 61.26% 50.39% / 26%)'
              : 'transparent',
            'border-radius': '50%',
          }"
          (click)="filtersOpened = !filtersOpened"
        ></p-button>
      </ng-template>
    </p-toolbar>
  </div>

  <!-- Main content card -->
  <p-card styleClass="products-card">
    <!-- Market Type Filter -->
    <div class="market-type-filter mb-3">
      <div class="filter-buttons">
        <p-button
          label="Tous ({{ getTotalCount() }})"
          [outlined]="selectedMarketTypeFilter !== null"
          [severity]="
            selectedMarketTypeFilter === null ? 'primary' : 'secondary'
          "
          (click)="filterByMarketType(null)"
          styleClass="market-filter-btn"
        ></p-button>
        @for (group of groupedProducts; track group.marketType) {
          <p-button
            [label]="group.marketType + ' (' + group.count + ')'"
            [outlined]="selectedMarketTypeFilter !== group.marketType"
            [severity]="
              selectedMarketTypeFilter === group.marketType
                ? 'primary'
                : 'secondary'
            "
            (click)="filterByMarketType(group.marketType)"
            styleClass="market-filter-btn"
            [ngClass]="getMarketTypeColorClass(group.colorIndex)"
          ></p-button>
        }
      </div>
    </div>

    <!-- Data table -->
    <p-table
      #dt
      [value]="(productsToPlanify$ | async) || []"
      [lazy]="true"
      [paginator]="true"
      [rows]="10"
      [rowsPerPageOptions]="[5, 10, 20, 50]"
      [totalRecords]="(totalRecords$ | async) || 0"
      [loading]="(loading$ | async) || false"
      styleClass="p-datatable-sm"
      [rowHover]="true"
      [scrollable]="true"
      (onLazyLoad)="lazyLoadEmit($event)"
    >
      <ng-template pTemplate="header">
        <tr>
          <th colspan="7" class="table-title">
            <h2>{{ filteredProducts.length }} affaire(s) trouvée(s)</h2>
          </th>
        </tr>
        <tr>
          <th>Référence ML</th>
          <th>Produit</th>
          <th>Type de marché</th>
          <th>Clients</th>
          <th>Adresse</th>
          <th>Rénovateur</th>
          <th>Assistant(e)</th>
          <th>Actions</th>
        </tr>
        <tr>
          <th>
            <input
              pInputText
              type="text"
              (input)="onColumnFilter($event, 'affair.mlRef')"
              placeholder="Rechercher"
              class="p-column-filter"
            />
          </th>
          <th>
            <input
              pInputText
              type="text"
              (input)="onColumnFilter($event, 'product.name')"
              placeholder="Rechercher"
              class="p-column-filter"
            />
          </th>
          <th>
            <!-- Empty header for Type de marché column -->
          </th>
          <th>
            <input
              pInputText
              type="text"
              (input)="
                onColumnFilter($event, 'affair.finalsCustomersFullNames')
              "
              placeholder="Rechercher"
              class="p-column-filter"
            />
          </th>
          <th>
            <input
              pInputText
              type="text"
              (input)="onColumnFilter($event, 'address')"
              placeholder="Rechercher code postal ou ville"
              class="p-column-filter"
            />
          </th>
          <th>
            <p-select
              placeholder="Rechercher"
              class="p-column-filter"
              [options]="allRenovators"
              [filter]="true"
              [(ngModel)]="selectedRenovator"
              (onChange)="applyFilters()"
            />
          </th>
          <th>
            <p-select
              placeholder="Rechercher"
              class="p-column-filter"
              [options]="allAssistants"
              [filter]="true"
              [(ngModel)]="selectedAssistant"
              (onChange)="applyFilters()"
            />
          </th>
          <th>
            <button
              pButton
              type="button"
              icon="pi pi-filter-slash"
              class="p-button-outlined p-button-sm clear-filters-btn"
              (click)="clearAllFilters()"
              pTooltip="Effacer tous les filtres"
            ></button>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-product>
        <tr
          class="cursor-pointer"
          [ngClass]="getRowColorClass(product.affair?.marketType?.name)"
        >
          <td (click)="navigateToAffair(product)">
            <div class="flex align-items-center">
              <p-tag
                severity="info"
                [value]="product.affair.mlRef"
                styleClass="mr-2"
              ></p-tag>
            </div>
          </td>
          <td (click)="navigateToAffair(product)">
            <div class="product-name">
              <span class="font-medium">{{ product.product.name }}</span>
            </div>
          </td>
          <td (click)="navigateToAffair(product)">
            <p-tag
              [value]="product.affair.marketType.name"
              [severity]="
                getMarketTypeSeverity(product.affair?.marketType?.name)
              "
              [style]="getMarketTypeTagStyle(product.affair?.marketType?.name)"
            ></p-tag>
          </td>
          <td (click)="navigateToAffair(product)">
            {{ product.affair.finalsCustomersFullNames }}
          </td>
          <td (click)="navigateToAffair(product)">
            <div class="address-info">
              <i class="pi pi-map-marker mr-2 text-primary"></i>
              <span
                >{{ product.affair.workSitePostalCode }}
                {{ product.affair.workSiteLocality }}</span
              >
            </div>
          </td>
          <td (click)="navigateToAffair(product)">
            <div class="address-info">
              <span>{{ product.agency.name }}</span>
            </div>
          </td>
          <td (click)="navigateToAffair(product)">
            <div class="address-info">
              <span
                >{{ product.affair.userAssistant.firstname }}
                {{ product.affair.userAssistant.lastname }}</span
              >
            </div>
          </td>
          <td>
            <div class="flex justify-content-center gap-2">
              <p-button
                icon="pi pi-eye"
                styleClass="p-button-rounded p-button-text p-button-info"
                pTooltip="Voir les détails"
                (click)="navigateToAffair(product)"
              ></p-button>
              <p-button
                icon="pi pi-calendar-plus"
                styleClass="p-button-rounded p-button-text p-button-info"
                pTooltip="Planifier"
                (click)="schedulePlanning(product)"
              ></p-button>
              <p-button
                icon="pi pi-external-link"
                styleClass="p-button-rounded p-button-text"
                pTooltip="Ouvrir dans Éros"
                (click)="navigateToEros(product)"
              ></p-button>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8">
            <div class="flex flex-column align-items-center p-5">
              <i class="pi pi-calendar-minus text-6xl text-500 mb-3"></i>
              <h3 class="m-0 text-500">Aucun produit à planifier</h3>
              <p class="text-500">
                Il n'y a aucun produit à planifier pour le moment.
              </p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
</div>

<!-- Heat Map Modal -->
<p-dialog
  header="Carte des départements"
  [(visible)]="isMapOpened"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="heat-map-dialog"
  [style]="{ width: '900px', height: '700px' }"
>
  <app-heat-map
    [isVisible]="isMapOpened"
    [erpSource]="this.mlSocieties[0].id"
    (departmentClicked)="onDepartmentClicked($event)"
  >
  </app-heat-map>
</p-dialog>
